var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckbox = function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#5998F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30047 16.5C9.69047 16.89 10.3205 16.89 10.7105 16.5L18.2905 8.91002C18.6805 8.52002 18.6805 7.89002 18.2905 7.50002C17.9005 7.11002 17.2705 7.11002 16.8805 7.50002L10.0005 14.38L7.12047 11.5C6.73047 11.11 6.10047 11.11 5.71047 11.5C5.32047 11.89 5.32047 12.52 5.71047 12.91L9.30047 16.5Z",
    fill: "white"
  })));
};
export default SvgCheckbox;